import React, { useState } from "react";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Cookies from "js-cookie";
import Eye from "../components/Eye";
import { pageRoutes } from "../routes/PageRoutes";
import { signInSchema } from "../auth/Schema";
import { userLogin } from "../redux/actions/authActions";
import ErrorMessage from "../components/ErrorMessage";
import Loader from "../components/Loader";
import { pipSaveProfile } from "../auth/Pip";
import WaterRipple from "../layout/RippleEffect";

const Login = () => {
  const { isLoading, fcm } = useSelector((state) => state?.authReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isEye, setIsEye] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const initialState = {
    email: Cookies.get("admin_user_email") ?? "",
    password: Cookies.get("admin_user_password" ?? ""),
  };

  const onHandleLogin = async (values, { setSubmitting }) => {
    setSubmitting(false);
    if (isChecked) {
      Cookies.set("admin_user_email", values?.email, { expires: 365 });
      Cookies.set("admin_user_password", values?.password, { expires: 365 });
    }
    const callback = (response) => {
      if (response.success) {
        const data = {
          id:response?.data?.userData?.id ?? "",
          name: response?.data?.userData?.first_name ?? "",
          company_name: response?.data?.userData?.company_name ?? "",
        };
        console.log({ data }, { response });
        console.log("data==>", data);
        pipSaveProfile(data);
        navigate(pageRoutes.dashboard);
      }
    };
    // const local = JSON.parse(localStorage.getItem('MarinfcmToken'))
    const data = {
      email: values?.email,
      password: values?.password,
      // fcm_token: local
    };
    dispatch(userLogin({ payload: data, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <section className="et_landing_main_bg">
        <div className="ct_header_flex">
          <div className="et_logo">
            <a href="javascript:void(0)" onClick={()=>{
              navigate(pageRoutes?.landingpage)
            }}>
              {" "}
              <img src="img/Logo_blue_new.png" />
            </a>
          </div>
          
        </div>

        <div class="auth-wrapper">
          <WaterRipple />
          <div class="container-fluid">
            <div class="ct-login-wrapper">
              <div class="ct-login-card ct_custom_scroll">
                <div class="text-center ct_mb_32">
                  <div class="ct-title ct_fs_24 ct_idlewild_bold mb-2 ct_blue_text ct_fs_20_575">
                    Welcome back
                  </div>
                  <div class="ct-subtitle ct_blue_text ct_ff_ProximaNova_regular mb-0 ct_fs_14 ct_fw_400">
                    We've missed you! Please sign in to catch up on what <br />
                    you've missed
                  </div>
                </div>
                <Formik
                  initialValues={initialState}
                  validationSchema={signInSchema}
                  onSubmit={(values, actions) => {
                    onHandleLogin(values, actions);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  }) => (
                    <form>
                      <div class="mb-3">
                        <label class="form-label small ct_ff_ProximaNova_regular ct_text_dark ct_fs_16 ct_fw_600 mb-1">
                          Email Address{" "}
                          <span className="ct_required_star">*</span>
                        </label>

                        <div class="position-relative">
                          <input
                            id="email"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values?.email}
                            type="email"
                            autocomplete="off"
                            class="form-control ct_input ct_border_radius_8 "
                            placeholder="Enter email"
                            required
                          />
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="email"
                          />
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="d-flex justify-content-between">
                          <label class="form-label small ct_ff_ProximaNova_regular ct_text_dark ct_fs_16 ct_fw_600 mb-1">
                            Password <span className="ct_required_star">*</span>
                          </label>
                          <a
                            onClick={() => navigate(pageRoutes.forgot_password)}
                            class="ct-forgot ct_blue_text ct_fs_14 ct_fw_600 ct_pointer"
                          >
                            Forgot Password?
                          </a>
                        </div>
                        <div class="position-relative">
                          <input
                            id="password"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values?.password}
                            type={isEye ? "text" : "password"}
                            autocomplete="off"
                            placeholder="Enter password"
                            class="form-control ct_input ct_input_pe_40  ct_border_radius_8"
                          />
                          <Eye isEye={isEye} onClick={() => setIsEye(!isEye)} />
                        </div>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="password"
                        />
                      </div>

                      <div class="ct_checkbox_main d-flex gap-2 align-items-center mb-4">
                        <div>
                          <input
                            onClick={() => setIsChecked(!isChecked)}
                            type="checkbox"
                            value={isChecked}
                            checked={isChecked}
                            id="ct_checkbox_cbx"
                            class="ct_hidden-xs-up"
                          />
                          <label
                            for="ct_checkbox_cbx"
                            class="ct_checkbox_cbx et_checkbox_clr"
                          ></label>
                        </div>
                        <p class="mb-0 ct_lh_0">Remember me</p>
                      </div>

                      <button
                        onClick={handleSubmit}
                        type="submit"
                        class="ct_orange_btn w-100"
                      >
                        {" "}
                        Log In{" "}
                        <svg
                          class="ms-2"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.175 9H0V7H12.175L6.575 1.4L8 0L16 8L8 16L6.575 14.6L12.175 9Z"
                            fill="white"
                          />
                        </svg>
                      </button>

                      <div class="ct_login_divider mt-3"></div>

                      <div class="ct_mt_25 text-center ct_text_dark ct_fs_14 ct-fw_400">
                        Don't have an account?{" "}
                        <a
                          href="javascript:void(0)"
                          onClick={() => navigate(pageRoutes.signup)}
                          class="ct_blue_text ct_fs_14 ct_fw_600"
                        >
                          Sign Up
                        </a>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
